(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("backbone"), require("underscore"));
	else if(typeof define === 'function' && define.amd)
		define("mdnotice", ["jquery", "backbone", "underscore"], factory);
	else if(typeof exports === 'object')
		exports["mdnotice"] = factory(require("jquery"), require("backbone"), require("underscore"));
	else
		root["mdnotice"] = factory(root["jQuery"], root["Backbone"], root["_"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/